// extracted by mini-css-extract-plugin
module.exports = {"main_hero":"MainHeroMassage_main_hero__2qZDy","trans_box":"MainHeroMassage_trans_box__2hhUA"};